import type { AiSkillsJournalEntry, AiSkillsOverview } from '@/api/aiSkillsAdmin';
import { AI_SKILL_KEYS, listeningEmpty, skillCounts, type AiSkillKey } from '@/lib/aiSkillsAdmin';

/**
 * Тексты карточки тумблеров ИИ (`AiSkillsServerCard.tsx`, заход 2, 16.10.2026).
 *
 * ⚠️ ЖИВУТ ЗДЕСЬ, А НЕ В lib/. Сторож слов ученика считает строку ученической, если её
 * ключ упомянут в файле на ученическом пути (`lib/` — такой); `pages/admin` — экран
 * сотрудника.
 */

type T = (key: string, opts?: Record<string, unknown>) => string;

/** Текст подтверждения переключения: числа учеников, а для Listening — записи. */
export function toggleConfirm(
  t: T,
  skill: AiSkillKey,
  nextOn: boolean,
  o: AiSkillsOverview | undefined,
): { message: string; confirmLabel: string; danger: boolean } {
  const name = t(`adminAiSkills.skill.${skill}`);
  const counts = skillCounts(o, skill);
  const parts: string[] = [];
  if (nextOn) {
    parts.push(
      counts
        ? t('adminAiSkills.confirmOn', { skill: name, now: counts.now, after: counts.after })
        : t('adminAiSkills.confirmOnNoCounts', { skill: name }),
    );
    if (skill === 'listening' && o) {
      parts.push(
        o.listening.ready === 0
          ? t('adminAiSkills.listeningNone')
          : t('adminAiSkills.listeningLine', { ready: o.listening.ready, approved: o.listening.approved }),
      );
    }
  } else {
    parts.push(
      counts
        ? t('adminAiSkills.confirmOff', { skill: name, now: counts.now })
        : t('adminAiSkills.confirmOffNoCounts', { skill: name }),
    );
  }
  parts.push(t('adminAiSkills.appliesWithin'));
  return {
    message: parts.join(' '),
    confirmLabel: t(nextOn ? 'adminAiSkills.turnOn' : 'adminAiSkills.turnOff'),
    danger: !nextOn || listeningEmpty(o, skill),
  };
}

/** Строка журнала: «Имя · 16.10 00:34 · Reading: выключено». */
export function journalLine(t: T, e: AiSkillsJournalEntry, formatAt: (iso: string) => string): string {
  const known = (AI_SKILL_KEYS as readonly string[]).includes(e.skill);
  return t('adminAiSkills.journalLine', {
    name: e.by_name || t('adminAiSkills.journalNoName'),
    at: formatAt(e.at),
    skill: known ? t(`adminAiSkills.skill.${e.skill}`) : e.skill,
    state: t(e.new ? 'adminAiSkills.stateOn' : 'adminAiSkills.stateOff'),
  });
}
